// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/admin_user_device.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/admin_user_device.proto.
 */
export const file_v1_admin_user_device: GenFile = /*@__PURE__*/
  fileDesc("Chp2MS9hZG1pbl91c2VyX2RldmljZS5wcm90bxICdjEiUQoWTGlzdFVzZXJEZXZpY2VzUmVxdWVzdBIWCg51c2VybmFtZV9xdWVyeRgBIAEoCRIMCgRwYWdlGAIgASgFEhEKCXBhZ2Vfc2l6ZRgDIAEoBSLNAgoKVXNlckRldmljZRIQCgh1c2VybmFtZRgBIAEoCRIRCglkZXZpY2VfaWQYAiABKAkSFAoMYnJvd3Nlcl9uYW1lGAMgASgJEhcKD2Jyb3dzZXJfdmVyc2lvbhgEIAEoCRIPCgdvc19uYW1lGAUgASgJEhIKCm9zX3ZlcnNpb24YBiABKAkSEwoLZGV2aWNlX3R5cGUYByABKAkSFAoMZGV2aWNlX21vZGVsGAggASgJEg4KBnNjcmVlbhgJIAEoCRISCgp1c2VyX2FnZW50GAogASgJEhIKCmxhc3RfZXZlbnQYCyABKAkSMQoNZmlyc3Rfc2Vlbl9hdBgMIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASMAoMbGFzdF9zZWVuX2F0GA0gASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCJJChdMaXN0VXNlckRldmljZXNSZXNwb25zZRIfCgdkZXZpY2VzGAEgAygLMg4udjEuVXNlckRldmljZRINCgV0b3RhbBgCIAEoBSIzChlHZXRVc2VyRGV2aWNlU3RhdHNSZXF1ZXN0EhYKDnVzZXJuYW1lX3F1ZXJ5GAEgASgJIjkKFFVzZXJEZXZpY2VTdGF0QnVja2V0Eg0KBWxhYmVsGAEgASgJEhIKCnVzZXJfY291bnQYAiABKAUivgEKGkdldFVzZXJEZXZpY2VTdGF0c1Jlc3BvbnNlEi4KDGRldmljZV90eXBlcxgBIAMoCzIYLnYxLlVzZXJEZXZpY2VTdGF0QnVja2V0EioKCG9zX25hbWVzGAIgAygLMhgudjEuVXNlckRldmljZVN0YXRCdWNrZXQSLwoNYnJvd3Nlcl9uYW1lcxgDIAMoCzIYLnYxLlVzZXJEZXZpY2VTdGF0QnVja2V0EhMKC3RvdGFsX3VzZXJzGAQgASgFMooCChZBZG1pblVzZXJEZXZpY2VTZXJ2aWNlEnIKD0xpc3RVc2VyRGV2aWNlcxIaLnYxLkxpc3RVc2VyRGV2aWNlc1JlcXVlc3QaGy52MS5MaXN0VXNlckRldmljZXNSZXNwb25zZSImgtPkkwIgOgEqIhsvdjEvYWRtaW4vdXNlci1kZXZpY2VzL2xpc3QSfAoSR2V0VXNlckRldmljZVN0YXRzEh0udjEuR2V0VXNlckRldmljZVN0YXRzUmVxdWVzdBoeLnYxLkdldFVzZXJEZXZpY2VTdGF0c1Jlc3BvbnNlIieC0+STAiE6ASoiHC92MS9hZG1pbi91c2VyLWRldmljZXMvc3RhdHNCKFomZ2l0aHViLmNvbS9kdWNidC90dC1nby9nZW4vcHJvdG8vdjE7djFiBnByb3RvMw", [file_google_api_annotations, file_google_protobuf_timestamp]);

/**
 * @generated from message v1.ListUserDevicesRequest
 */
export type ListUserDevicesRequest = Message<"v1.ListUserDevicesRequest"> & {
  /**
   * Case-insensitive substring of the username. Empty lists every user.
   *
   * @generated from field: string username_query = 1;
   */
  usernameQuery: string;

  /**
   * 1-based. Values below 1 are treated as 1.
   *
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * Default 50, max 200.
   *
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;
};

/**
 * Describes the message v1.ListUserDevicesRequest.
 * Use `create(ListUserDevicesRequestSchema)` to create a new message.
 */
export const ListUserDevicesRequestSchema: GenMessage<ListUserDevicesRequest> = /*@__PURE__*/
  messageDesc(file_v1_admin_user_device, 0);

/**
 * @generated from message v1.UserDevice
 */
export type UserDevice = Message<"v1.UserDevice"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string device_id = 2;
   */
  deviceId: string;

  /**
   * @generated from field: string browser_name = 3;
   */
  browserName: string;

  /**
   * @generated from field: string browser_version = 4;
   */
  browserVersion: string;

  /**
   * @generated from field: string os_name = 5;
   */
  osName: string;

  /**
   * @generated from field: string os_version = 6;
   */
  osVersion: string;

  /**
   * @generated from field: string device_type = 7;
   */
  deviceType: string;

  /**
   * @generated from field: string device_model = 8;
   */
  deviceModel: string;

  /**
   * @generated from field: string screen = 9;
   */
  screen: string;

  /**
   * @generated from field: string user_agent = 10;
   */
  userAgent: string;

  /**
   * login | refresh
   *
   * @generated from field: string last_event = 11;
   */
  lastEvent: string;

  /**
   * @generated from field: google.protobuf.Timestamp first_seen_at = 12;
   */
  firstSeenAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp last_seen_at = 13;
   */
  lastSeenAt?: Timestamp;
};

/**
 * Describes the message v1.UserDevice.
 * Use `create(UserDeviceSchema)` to create a new message.
 */
export const UserDeviceSchema: GenMessage<UserDevice> = /*@__PURE__*/
  messageDesc(file_v1_admin_user_device, 1);

/**
 * @generated from message v1.ListUserDevicesResponse
 */
export type ListUserDevicesResponse = Message<"v1.ListUserDevicesResponse"> & {
  /**
   * @generated from field: repeated v1.UserDevice devices = 1;
   */
  devices: UserDevice[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message v1.ListUserDevicesResponse.
 * Use `create(ListUserDevicesResponseSchema)` to create a new message.
 */
export const ListUserDevicesResponseSchema: GenMessage<ListUserDevicesResponse> = /*@__PURE__*/
  messageDesc(file_v1_admin_user_device, 2);

/**
 * @generated from message v1.GetUserDeviceStatsRequest
 */
export type GetUserDeviceStatsRequest = Message<"v1.GetUserDeviceStatsRequest"> & {
  /**
   * Case-insensitive substring of the username. Empty counts every user.
   *
   * @generated from field: string username_query = 1;
   */
  usernameQuery: string;
};

/**
 * Describes the message v1.GetUserDeviceStatsRequest.
 * Use `create(GetUserDeviceStatsRequestSchema)` to create a new message.
 */
export const GetUserDeviceStatsRequestSchema: GenMessage<GetUserDeviceStatsRequest> = /*@__PURE__*/
  messageDesc(file_v1_admin_user_device, 3);

/**
 * One bar of a breakdown: how many users have a device with this value.
 *
 * @generated from message v1.UserDeviceStatBucket
 */
export type UserDeviceStatBucket = Message<"v1.UserDeviceStatBucket"> & {
  /**
   * The raw stored value, e.g. "mobile", "iOS", "Safari". Empty when unknown.
   *
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * Distinct users, not device rows: a user with a phone and a computer has
   * two rows.
   *
   * @generated from field: int32 user_count = 2;
   */
  userCount: number;
};

/**
 * Describes the message v1.UserDeviceStatBucket.
 * Use `create(UserDeviceStatBucketSchema)` to create a new message.
 */
export const UserDeviceStatBucketSchema: GenMessage<UserDeviceStatBucket> = /*@__PURE__*/
  messageDesc(file_v1_admin_user_device, 4);

/**
 * @generated from message v1.GetUserDeviceStatsResponse
 */
export type GetUserDeviceStatsResponse = Message<"v1.GetUserDeviceStatsResponse"> & {
  /**
   * Each list is sorted by user_count descending, then label ascending.
   *
   * @generated from field: repeated v1.UserDeviceStatBucket device_types = 1;
   */
  deviceTypes: UserDeviceStatBucket[];

  /**
   * @generated from field: repeated v1.UserDeviceStatBucket os_names = 2;
   */
  osNames: UserDeviceStatBucket[];

  /**
   * @generated from field: repeated v1.UserDeviceStatBucket browser_names = 3;
   */
  browserNames: UserDeviceStatBucket[];

  /**
   * Distinct users counted. A user with an iPhone and a PC appears in two
   * buckets of a list, so a list can sum to more than this.
   *
   * @generated from field: int32 total_users = 4;
   */
  totalUsers: number;
};

/**
 * Describes the message v1.GetUserDeviceStatsResponse.
 * Use `create(GetUserDeviceStatsResponseSchema)` to create a new message.
 */
export const GetUserDeviceStatsResponseSchema: GenMessage<GetUserDeviceStatsResponse> = /*@__PURE__*/
  messageDesc(file_v1_admin_user_device, 5);

/**
 * AdminUserDeviceService lets administrators see which browsers, operating
 * systems and devices each user signs in from. Admin role only.
 *
 * @generated from service v1.AdminUserDeviceService
 */
export const AdminUserDeviceService: GenService<{
  /**
   * List devices, most recently seen first, optionally filtered by username.
   *
   * @generated from rpc v1.AdminUserDeviceService.ListUserDevices
   */
  listUserDevices: {
    methodKind: "unary";
    input: typeof ListUserDevicesRequestSchema;
    output: typeof ListUserDevicesResponseSchema;
  },
  /**
   * Count users by the device type, operating system and browser they sign in
   * with, optionally filtered by username. Backs the admin breakdown charts.
   *
   * @generated from rpc v1.AdminUserDeviceService.GetUserDeviceStats
   */
  getUserDeviceStats: {
    methodKind: "unary";
    input: typeof GetUserDeviceStatsRequestSchema;
    output: typeof GetUserDeviceStatsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_admin_user_device, 0);

